(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yunsho-founder"]) return;
  try {
    
(() => {
  const controllers = new WeakMap();

  function rootsWithin(scope) {
    const roots = [...scope.querySelectorAll(".ys-founder")];
    if (scope.matches?.(".ys-founder")) roots.unshift(scope);
    return roots;
  }

  function init(root) {
    if (controllers.has(root) || !window.IntersectionObserver ||
        !window.matchMedia || !Element.prototype.animate) return;

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reducedMotion.matches) return;

    const desktop = window.matchMedia("(min-width: 768px)");
    const active = new Map();
    const seen = new WeakSet();
    let stopped = false;

    const observer = new IntersectionObserver((entries) => {
      if (stopped) return;
      for (const entry of entries) {
        const target = entry.target;
        if (!entry.isIntersecting) {
          if (active.has(target)) {
            active.get(target).cancel();
            active.delete(target);
            observer.unobserve(target);
          }
          continue;
        }
        if (seen.has(target)) continue;
        seen.add(target);
        const rect = target.getBoundingClientRect();
        if (!target.isConnected || rect.bottom <= 0 || rect.top >= window.innerHeight) {
          observer.unobserve(target);
          continue;
        }
        const frames = desktop.matches
          ? [{ opacity: 0.65, transform: "translateY(6px)" }, { opacity: 1, transform: "translateY(0)" }]
          : [{ opacity: 0.65 }, { opacity: 1 }];
        const animation = target.animate(frames, {
          duration: 300,
          easing: "cubic-bezier(0.22, 1, 0.36, 1)"
        });
        active.set(target, animation);
        const finish = () => {
          if (active.get(target) === animation) active.delete(target);
          observer.unobserve(target);
        };
        animation.finished.then(finish, finish);
      }
    }, { threshold: 0 });

    function stop() {
      stopped = true;
      observer.disconnect();
      for (const animation of active.values()) animation.cancel();
      active.clear();
      reducedMotion.removeEventListener("change", onPreferenceChange);
    }

    function onPreferenceChange(event) {
      if (event.matches) stop();
    }

    controllers.set(root, stop);
    reducedMotion.addEventListener("change", onPreferenceChange);
    for (const target of root.querySelectorAll(".photo img, h2")) {
      if (target.closest(".hero")) continue;
      const rect = target.getBoundingClientRect();
      if (rect.top >= window.innerHeight) observer.observe(target);
    }
  }

  rootsWithin(document).forEach(init);
  document.addEventListener("shopify:section:load", (event) => {
    rootsWithin(event.target).forEach(init);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    for (const root of rootsWithin(event.target)) {
      controllers.get(root)?.();
      controllers.delete(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunsho-home-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.yunshoHomeMotion) return;
    window.yunshoHomeMotion = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animated = new Set();
    const observed = new WeakSet();
    const reviewLayouts = new Map();
    function setupReviews(root) {
      const section = root.matches?.('[id$="__17883371685f0d0d7a"]') ? root : root.querySelector('[id$="__17883371685f0d0d7a"]');
      const wrapper = section?.querySelector('.jdgm-cards-wrapper');
      if (!wrapper || reviewLayouts.has(wrapper) || !('ResizeObserver' in window)) return;
      let previousWidth = 0;
      const layout = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (Math.abs(width - previousWidth) < 1) return;
        previousWidth = width;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!wrapper.isConnected) return;
          const active = wrapper.querySelector('.jdgm-card.active');
          const track = wrapper.querySelector('.jdgm-videos-container');
          if (!active || !track || !track.style.transform) return;
          const delta = wrapper.getBoundingClientRect().left - active.getBoundingClientRect().left;
          if (Math.abs(delta) < 1) return;
          const transform = new DOMMatrixReadOnly(getComputedStyle(track).transform);
          track.style.transform = `translateX(${transform.m41 + delta}px)`;
        }));
      });
      reviewLayouts.set(wrapper, layout);
      layout.observe(wrapper);
    }
    function setupHero() {
      const hero = document.querySelector('[id$="__featured_video_LQy9B7"]');
      const video = hero?.querySelector('video');
      const labels = document.querySelector('.ys-home--facts');
      if (!video || !labels || hero.querySelector('.ys-home-pause')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ys-home-pause';
      button.innerHTML = '<svg class="ys-home-pause__play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg><svg class="ys-home-pause__pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zm6 0h4v14h-4z"/></svg>';
      let allowPlayback = !reduced.matches;
      const label = () => {
        const action = video.paused ? labels.dataset.playLabel : labels.dataset.pauseLabel;
        button.dataset.state = video.paused ? 'paused' : 'playing';
        button.setAttribute('aria-label', action);
        button.title = action;
      };
      button.addEventListener('click', () => {
        if (video.paused) {allowPlayback = true; video.play().catch(() => {});}
        else {allowPlayback = false; video.pause();}
        label();
      });
      video.addEventListener('play', () => {if (!allowPlayback) video.pause(); label();});
      video.addEventListener('pause', label);
      reduced.addEventListener('change', () => {if (reduced.matches) {allowPlayback = false; video.pause(); label();}});
      if (reduced.matches) video.pause();
      label();
      hero.querySelector('.video--wrapper').appendChild(button);
    }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (reduced.matches || entry.boundingClientRect.bottom < 0 || !entry.target.animate) return;
        const desktop = window.matchMedia('(min-width: 768px)').matches;
        if (entry.target.hasAttribute('data-home-copy-reveal')) {
          if (entry.target.contains(document.activeElement)) return;
          Array.from(entry.target.children).forEach((node, index) => {
            const target = node.matches('.ys-home__kicker') ? node.firstElementChild : node;
            const animation = target.animate([{opacity: 0, transform: `translateY(${desktop ? 10 : 6}px)`}, {opacity: 1, transform: 'none'}], {duration:700,delay:index * 500,easing:'cubic-bezier(0.45, 0.05, 0.55, 0.95)',fill:'backwards'});
            animated.add(animation);
            animation.finished.catch(() => {}).finally(() => animated.delete(animation));
          });
          return;
        }
        const animation = entry.target.animate([{opacity: .7, transform: desktop ? 'translateY(8px)' : 'none'}, {opacity: 1, transform: 'none'}], {duration:400,easing:'ease-out'});
        animated.add(animation);
        animation.finished.catch(() => {}).finally(() => animated.delete(animation));
      });
    }, {threshold:.08}) : null;
    function start(root) {
      setupHero();
      setupReviews(root);
      if (!observer || reduced.matches) return;
      root.querySelectorAll('[data-home-reveal], [data-home-copy-reveal]').forEach(node => {
        if (observed.has(node)) return;
        observed.add(node);
        const box = node.getBoundingClientRect();
        if (box.top >= window.innerHeight) observer.observe(node);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
    else start(document);
    document.addEventListener('shopify:section:load', event => start(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-home-reveal], [data-home-copy-reveal]').forEach(node => observer?.unobserve(node));
      reviewLayouts.forEach((layout, wrapper) => {if (event.target.contains(wrapper)) {layout.disconnect(); reviewLayouts.delete(wrapper);}});
    });
    reduced.addEventListener('change', () => {if (reduced.matches) {observer?.disconnect(); animated.forEach(animation => animation.cancel());}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunsho-tea-pdp"] && !Shopify.designMode) return;
  try {
    
  class YunshoVideoDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.dialogVideo = this.dialog?.querySelector('video');
      this.previewVideo = this.querySelector('.yunsho-tea--video-autoplay');
      this.triggers = this.querySelectorAll('.yunsho-tea--video-trigger');
      this.closeButton = this.querySelector('.yunsho-tea--video-close');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.previewToggle = this.querySelector('[data-preview-toggle]');
      this.previewUserPaused = false;
      this.previewUserRequested = false;
      this.previewToggle?.addEventListener('click', this.togglePreview);
      this.previewVideo?.addEventListener('play', this.syncPreviewControl);
      this.previewVideo?.addEventListener('pause', this.syncPreviewControl);
      this.syncPreviewControl();
      if (this.previewToggle && this.reduceMotion) {
        this.previewToggle.dataset.paused = 'true';
        this.previewToggle.setAttribute('aria-label', 'Play brewing video');
      }
      this.previewInView = false;
      this.triggers.forEach((trigger) => trigger.addEventListener('click', this.open));
      this.closeButton?.addEventListener('click', this.close);
      this.dialog?.addEventListener('click', this.onBackdrop);
      this.dialog?.addEventListener('close', this.pause);
      this.initPreviewAutoplay();
    }
    open = () => {
      this.previewVideo?.pause();
      if (this.dialog && !this.dialog.open) this.dialog.showModal();
    };
    close = () => this.dialog?.close();
    pause = () => {
      this.dialogVideo?.pause();
      this.syncPreviewPlayback();
    };
    syncPreviewPlayback = () => {
      if (!this.previewVideo || (this.reduceMotion && !this.previewUserRequested) || this.previewUserPaused || this.dialog?.open || !this.previewInView) {
        this.previewVideo?.pause();
        return;
      }
      const playPromise = this.previewVideo.play();
      if (playPromise) playPromise.catch(() => {});
    };
    syncPreviewControl = () => {
      if (!this.previewToggle || !this.previewVideo) return;
      this.previewToggle.dataset.paused = String(this.previewVideo.paused);
      this.previewToggle.setAttribute('aria-label', this.previewVideo.paused ? 'Play brewing video' : 'Pause brewing video');
    };
    togglePreview = () => {
      this.previewUserRequested = true;
      this.previewUserPaused = !this.previewVideo.paused;
      this.previewToggle.dataset.paused = String(this.previewUserPaused);
      this.previewToggle.setAttribute('aria-label', this.previewUserPaused ? 'Play brewing video' : 'Pause brewing video');
      this.syncPreviewPlayback();
    };
    initPreviewAutoplay = () => {
      if (!this.previewVideo || !('IntersectionObserver' in window)) return;
      this.previewVideo.muted = true;
      this.previewVideo.playsInline = true;
      this.previewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.previewInView = entry.isIntersecting && entry.intersectionRatio >= 0.55;
          this.syncPreviewPlayback();
        });
      }, { threshold: [0, 0.55] });
      this.previewObserver.observe(this.previewVideo);
    };
    onBackdrop = (event) => {
      if (event.target === this.dialog) this.close();
    };
    disconnectedCallback() {
      this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.open));
      this.closeButton?.removeEventListener('click', this.close);
      this.previewToggle?.removeEventListener('click', this.togglePreview);
      this.previewVideo?.removeEventListener('play', this.syncPreviewControl);
      this.previewVideo?.removeEventListener('pause', this.syncPreviewControl);
      this.dialog?.removeEventListener('click', this.onBackdrop);
      this.dialog?.removeEventListener('close', this.pause);
      this.previewObserver?.disconnect();
      this.previewVideo?.pause();
    }
  }

  if (!customElements.get('yunsho-video-dialog')) {
    customElements.define('yunsho-video-dialog', YunshoVideoDialog);
  }

  const initYunshoTeaMotion = (root) => {
    if (!root || root.dataset.motionInitialized === 'true') return;
    root.dataset.motionInitialized = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = root.querySelectorAll(
      '.yunsho-tea--section-header, .yunsho-tea--profile-copy, .yunsho-tea--value-list, .yunsho-tea--craft-copy, .yunsho-tea--brewing-copy, .yunsho-tea--culture-copy'
    );
    if (!targets.length) return;

    root.dataset.motionReady = 'true';
    targets.forEach((target) => {
      target.classList.add('yunsho-tea--reveal');
      if (!target.classList.contains('yunsho-tea--section-header')) target.dataset.revealDelay = '1';
    });

    const reveal = (target) => { target.dataset.revealed = 'true'; };
    if (!('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    targets.forEach((target) => observer.observe(target));
  };

  document.querySelectorAll('.yunsho-tea').forEach(initYunshoTeaMotion);
  document.addEventListener('shopify:section:load', (event) => {
    initYunshoTeaMotion(event.target.querySelector('.yunsho-tea'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunsho-tea-sampler"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yunsho-sampler-recipes')) {
    customElements.define('yunsho-sampler-recipes', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const select = this.querySelector('select');
        const picker = this.querySelector('.yunsho-sampler__recipe-picker');
        const recipes = [...this.querySelectorAll('[data-recipe]')];
        if (!select || !picker || !recipes.length) return;
        const showRecipe = () => {
          recipes.forEach(recipe => {
            const active = recipe.dataset.recipe === select.value;
            recipe.hidden = !active;
            recipe.open = active;
          });
        };
        showRecipe();
        select.addEventListener('change', showRecipe);
        picker.hidden = false;
        this.dataset.ready = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
